import * as React from "react";
import { IPosition } from "@nkr/models/index";

import { Button, Glyphicon } from "react-bootstrap";

interface ISwapRowProps {
    index: number,
    position: IPosition,
    include: boolean,
    responsible: string,
    showInclude: boolean,
    onIncludeChange: (clusterNumber: number, positionNumber: number, include: boolean) => void,
    onResponsibleChange: (clusterNumber: number, positionNumber: number, responsible: string) => void
}

const RccapSwapListRow = (props: ISwapRowProps) => {
    const handleInclude = (e: React.FormEvent<any>) => {
        props.onIncludeChange(props.position.clusterNumber, props.position.positionNumber, !props.include);
    }

    const handleResponsibleChange = (e: React.FormEvent<any>) => {
        props.onResponsibleChange(props.position.clusterNumber, props.position.positionNumber, e.currentTarget.value);
    }

    const responsibleCenter = () => {
        const donor = props.position.donor;

        return (
            <td>
                {donor.center.alias}
                {donor.rdnCenterId > 0 && (
                    <div>(<span style={{ fontSize: 12, color: 'red' }}>{donor.rdnCenterAlias}</span>)</div>
                )}
            </td>
        )
    }

    const includeIcon = props.include ? "check" : "unchecked";
    const donorResponsibleLabel = props.responsible == "donorCenter" ? <Glyphicon glyph="ok-sign" /> : <Glyphicon glyph="question-sign" />;
    const donorResponsibleStyle = props.responsible == "donorCenter" ? "danger" : "default";
    const recipientResponsibleLabel = props.responsible == "recipientCenter" ? <Glyphicon glyph="ok-sign" /> : <Glyphicon glyph="question-sign" />;
    const recipientResponsibleStyle = props.responsible == "recipientCenter" ? "danger" : "default";

    return (
        <tr>
            <td>{props.position.chainId} / {props.position.clusterNumber} / {props.position.positionNumber}</td>
            <td>{props.position.donor.alias}</td>
            {responsibleCenter()}

            <td>
                {props.position.recipient.id != -1 ?
                    <Button value="donorCenter" bsStyle={donorResponsibleStyle} bsSize="xs" onClick={handleResponsibleChange}>{donorResponsibleLabel}</Button>
                    : null}
            </td>

            <td>{props.position.recipient.alias}</td>
            <td>{props.position.recipient.center.alias}</td>

            <td>
                {props.position.recipient.id != -1 ?
                    <Button value="recipientCenter" bsStyle={recipientResponsibleStyle} bsSize="xs" onClick={handleResponsibleChange}>{recipientResponsibleLabel}</Button>
                    : null}
            </td>

            <td>
                {props.showInclude ?
                    <Glyphicon glyph={includeIcon} onClick={handleInclude} />
                    : null}
            </td>
        </tr>
    );
}

export default RccapSwapListRow;